<script src="../../../config/dev.env.js"></script>
<template>
  <div class="Sidebar d-none d-lg-flex">
    <div class="userinfoBox yuanjiao">
      <div class="headPortrait mb-3" v-if="localUser !== null && localUser.headPortrait !== ''" :style="{backgroundImage:'url('+ossImgDomain+localUser.headPortrait+')'}"></div>
      <img class="mb-3" v-if="localUser === null || localUser.headPortrait===''" src="/static/images/touxiang.jpg">
      <h6 v-if="localUser!==null">{{localUser.name}}</h6>
      <h6 @click="toLogin" class="cursor" v-else>未登录</h6>
      <p class="content">商城会员</p>
      <router-link active-class='active' class="btn btn-primary btn-round" tag='span' to="/about/lianxi">
        <i class="iconfont icon-user-group-fill"></i> 联系我们
      </router-link>
    </div>
    <div class="pingBox mb-4" id="pingBox">
      <div class="menuBox dingBox" style="width: 100%;">
        <router-link v-for="(app,index) in navData" active-class='active' :key="index" tag='a' class="huanchongKuai yuanjiao" :to="app.to">
          <i class="iconfont" :class="app.class"></i>
          <span>{{app.title}}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector';
import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';

export default {
  name: 'Sidebar',
  mixins: [generalMix],
  data () {
    return {
      // 阿里云域名头
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 导航
      navData: [
        {to:'/home/index','class':'icon-shouye','title':'个人主页'},
        {to:'/home/message','class':'icon-tongzhi','title':'我的消息'},
        {to:'/home/order','class':'icon-qinghuiyuan','title':'我的订单'},
        {to:'/home/coupon','class':'icon-qinghuiyuan','title':'优惠券'},
        {to:'/home/cashback','class':'icon-fanxianjilu2-xianxing','title':'返现抵扣'},
        {to:'/home/invoice','class':'icon-wenjuan','title':'发票管理'},
        {to:'/home/info','class':'icon-wodeguanzhu','title':'个人信息'},
      ]
    }
  },
  methods:{
    toLogin() {
      this.$router.push({ path: '/login' });
    },
    showWeicode() {
      EventBus.$emit('globalRightBoxFun', { type: 2, obj: { title:'联系微信' } });
    }
  },
  mounted() {
    $('.dingBox').pin({
      containerSelector: '.pingBox',
      minWidth: 992
    })
    // 侧边栏
    const _this = this;
    const erd = elementResizeDetectorMaker();
    erd.listenTo($('#pingBox'), element => {
      _this.$nextTick(() => {
        //监听到事件后执行的业务逻辑
        $('.dingBox').pin({
          containerSelector: '.pingBox',
          minWidth: 992,
          padding:{
            top: 60
          }
        })
      });
    });
  },
  created() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

  div.Sidebar{
    display: flex;
    flex-direction: column;
    width: 250px;
    background: #FFFFFF;
    border-radius: 10px;
    color: #000000;
    margin-bottom: 20px;
    .userinfoBox{
      text-align: center;
      padding:25px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      div.headPortrait{
        width: 96px;
        height: 96px;
        border-radius: 50%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url("/static/images/touxiang.jpg");
      }
      img{
        width: 96px;
        height: 96px;
        border-radius: 50%;
      }
      h6{
        font-family: '微软雅黑';
        font-weight: bold;
        font-size: 16px;
      }
      /*span{*/
      /*  display: inline-block;*/
      /*  background: #FFFFFF;*/
      /*  padding: .8rem 1.25rem;*/
      /*  border-radius: 50px;*/
      /*  color: #333333;*/
      /*  cursor: pointer;*/
      /*  border: 1px solid #007BFF;*/
      /*  &:hover{*/
      /*    background: rgba(0,0,0,0.05);*/
      /*  }*/
      /*}*/
    }
    .pingBox{
      flex: 1;
      //.dingBox
      .menuBox{
        grid-template-columns: 1fr;
        display: grid;
        grid-gap: 10px;
        padding: 0 25px;
        a{
          padding: 10px 20px;
          cursor: pointer;
          /*background: rgba(0,0,0,0.02);*/
          i{
            font-size: 18px;
            margin-top: 10px;
          }
          span{
            margin-top: 6px;
          }
          &:hover{
            background: #F0F0F0;
            color: #000000;
          }
          &.active{
            background: #F0F0F0;
            color: #000000;
          }
        }
      }
    }
  }
  @media (max-width: 1200px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 767px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue